// extracted by mini-css-extract-plugin
export default {"row":"grid_row__zOPNM"};